import ajax from '../plugin/ajax'
import {
    rejects
} from 'assert';

/**
 * 获取通讯录信息
 */
const getContactDetail = function (userId) {
    return new Promise((resolve, reject) => {
        ajax.get('/vipapi/address/contact', {
            params: {
                aid: userId
            }
        }).then(res => {
            if (res.status === 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

const getAllConctact = function (options) {
    if (!options.size) options.size = 50
    return new Promise((resolve, reject) => {
        ajax.get('/vipapi/address/contactall', {
            params: {
                page: options.page,
                length: options.size,
                isimportant: options.isimportant
            }
        }).then(res => {
            if (res.status === 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

const getRecentConctact = function () {
    return new Promise((resolve, reject) => {
        ajax.get('/vipapi/address/recent').then(res => {
            if (res.status === 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

const deleteContact = function (userId) {
    return new Promise((resolve, reject) => {
        ajax.delete('/vipapi/address/contact', {
            data: {
                aids: userId
            }
        }).then(res => {
            if (res.status === 200) {
                resolve(true)
            } else {
                reject()
            }
        })
    })
}

const deleteRecentContact = function (email) {
    return new Promise((resolve, reject) => {
        ajax.delete('/vipapi/address/recent', {
            data: {
                emails: email
            }
        }).then(res => {
            if (res.status === 200) {
                resolve(true)
            } else {
                reject()
            }
        })
    })
}

const editContact = function (data) {
    let method = data.hasOwnProperty('aid') && data.aid ? 'put' : 'post'
    return new Promise((resolve, reject) => {
        ajax[method]('/vipapi/address/contact', data).then(res => {
            if (res.status === 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

const getHomeList = function () {
    return new Promise((resolve, reject) => {
        ajax.get('/vipapi/address/homelist').then(res => {
            if (res.status === 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

const setImpContact = function (userId, important) {
    return new Promise((resolve, reject) => {
        ajax.post('/vipapi/address/contactimp', {
            aid: userId,
            isimportant: important
        }).then(res => {
            if (res.status === 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

const getGroupContact = function (options) {
    if (!options.size) options.size = 50
    return new Promise((resolve, reject) => {
        ajax.get('/vipapi/address/group', {
            params: {
                page: options.page,
                length: options.size,
                gid: options.gid
            }
        }).then(res => {
            if (res.status === 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

const moveUserToGroup = function (data) {
    return new Promise((resolve, reject) => {
        ajax.post('/vipapi/address/usergroup', data).then(res => {
            if (res.status === 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

const getWriteContact = function () {
    return new Promise((resolve, reject) => {
        ajax.get('/vipapi/address/completelist').then(res => {
            if (res.status === 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

const addGroup = function (groupname, ids=[]) {
    return new Promise((resolve, reject) => {
        ajax.post('/vipapi/address/group', {
            groupname: groupname,
            aids: ids
        }).then(res => {
            if (res.status == 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

const deleteGroup = function (gid) {
    return new Promise((resolve, reject) => {
        ajax.delete('/vipapi/address/group', {
            params: {
                gid: gid
            }
        }).then(res => {
            if (res.status === 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

const modifyGroup = function (gid, gname, ids) {
    return new Promise((resolve, reject) => {
        ajax.put('/vipapi/address/group', {
            gid: gid,
            groupname: gname,
            aids: ids
        }).then(res => {
            if (res.status === 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    })

}

const getGroup = function (gid) {
    return new Promise((resolve, reject) => {
        ajax.get('/vipapi/address/group', {
            params: {
                pagination: 0,
                gid: gid
            }
        }).then(res => {
            if (res.status === 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

export {
    getContactDetail,
    getHomeList,
    getAllConctact,
    getRecentConctact,
    deleteContact,
    deleteRecentContact,
    setImpContact,
    getGroupContact,
    moveUserToGroup,
    editContact,
    getWriteContact,
    addGroup,
    getGroup,
    modifyGroup,
    deleteGroup
}



// WEBPACK FOOTER //
// ./src/service/contactService.js